import '../styles/base.css'
import '../styles/modal.css'
import '../styles/slide1-hook.css'
import '../styles/slide3-bookings.css'
import '../styles/slide4-features.css'
import '../styles/slide5-seo.css'
import '../styles/slide6-who.css'
import '../styles/slide7-proof.css'
import '../styles/slide8-close.css'

console.log('[Pool Masters] JS build: 2026-05-03 v2')

import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'

createInertiaApp({
  resolve: name => {
    const pages = import.meta.glob('../pages/**/*.jsx')
    return pages[`../pages/${name}.jsx`]()
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
